import { useQuery } from '@tanstack/react-query'
import { fetchGallery } from '../api/gallery'

// REST API returns { caption, event_type } — normalize to match component expectations
function normalizeGalleryItem(item) {
  return {
    ...item,
    gallery_caption:    item.gallery_caption    ?? item.caption,
    gallery_event_type: item.gallery_event_type ?? item.event_type,
  }
}

const FALLBACK_GALLERY = [
  { id: 1, gallery_event_type: 'Decoration',     gallery_caption: 'Balloon arch setup',       image: { url: '', alt: '' } },
  { id: 2, gallery_event_type: 'Decoration',     gallery_caption: 'Princess theme table',      image: { url: '', alt: '' } },
  { id: 3, gallery_event_type: 'Characters',     gallery_caption: 'Superhero character visit', image: { url: '', alt: '' } },
  { id: 4, gallery_event_type: 'Entertainment',  gallery_caption: 'Kids dance floor',          image: { url: '', alt: '' } },
  { id: 5, gallery_event_type: 'Cakes',          gallery_caption: 'Custom birthday cake',      image: { url: '', alt: '' } },
  { id: 6, gallery_event_type: 'Decoration',     gallery_caption: 'Jungle adventure theme',    image: { url: '', alt: '' } },
  { id: 7, gallery_event_type: 'Characters',     gallery_caption: 'Princess character visit',  image: { url: '', alt: '' } },
  { id: 8, gallery_event_type: 'Entertainment',  gallery_caption: 'Puppet show performance',   image: { url: '', alt: '' } },
]

/**
 * @param {string} [category]  Optional event-type filter for server-side filtering.
 *                             Leave empty for all items; filter client-side in Gallery.jsx.
 */
export function useGallery(category = '') {
  const query = useQuery({
    queryKey: ['gallery', category],
    queryFn: () => fetchGallery(category),
    staleTime: 10 * 60 * 1000,
    retry: 1,
    placeholderData: FALLBACK_GALLERY,
    select: (raw) => (Array.isArray(raw) ? raw.map(normalizeGalleryItem) : raw),
  })

  return {
    ...query,
    data: query.data ?? FALLBACK_GALLERY,
  }
}

export { FALLBACK_GALLERY }
